module.exports = __webpack_public_path__ + "static/jeroen-bbbdd187210c8dd371db24f236ed93ad.png";